export default __webpack_public_path__ + "static/media/collaborate-with-others.081affc0.png";